export default {"src":"/_next/static/media/Malta.2de807cc.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};